import type {CallbackMessageWithResponse, RequestMessage} from '@bpinc/adapters-public-api-types'
import {agentStates, chatChannelTypes} from '@bpinc/adapters-public-api-types'

import type {Constraint} from './type-checkers'


export const requestMessageTypeConstraints: Record<RequestMessage, Constraint[]> = {
    GET_LOGIN_STATE: [],
    OPEN_LOGIN: [],
    LOGOUT: [],
    GET_AGENT_STATE: [],
    SET_AGENT_STATE: [
        {values: agentStates},
        {types: ['string', 'undefined']},
    ],
    ACCEPT_INTERACTION: [{types: ['string', 'undefined']}],
    REJECT_INTERACTION: [{types: ['string', 'undefined']}],
    START_CALL: [
        {types: ['string']},
        {types: ['interactionAssociatedObjectsArray']},
        {types: ['contactDetails', 'undefined']},
    ],
    START_CHAT: [
        {values: chatChannelTypes},
        {types: ['string']},
        {types: ['interactionAssociatedObjectsArray']},
        {types: ['contactDetails', 'undefined']},
    ],
    START_EMAIL: [
        {types: ['string']},
        {types: ['interactionAssociatedObjectsArray']},
        {types: ['contactDetails', 'undefined']},
    ],
    SEND_DTMF: [
        {types: ['string']},
        {types: ['string', 'undefined']},
    ],
    CONSULT_CALL: [{types: ['string']}],
    BLIND_TRANSFER: [
        {types: ['string']},
        {types: ['primitiveObject', 'undefined']},
        {types: ['string', 'undefined']},
    ],
    TRANSFER: [{types: ['primitiveObject', 'undefined']}],
    LEAVE_INTERACTION: [{types: ['string', 'undefined']}],
    COMPLETE_INTERACTION: [{types: ['string', 'undefined']}],
    LEAVE_AND_COMPLETE_INTERACTION: [
        {types: ['string', 'undefined']},
        {types: ['string', 'undefined']},
        {types: ['string', 'undefined']},
    ],
    SWITCH_ACTIVE_INTERACTION: [{types: ['string']}],
    INVITE_TO_CALL_CONFERENCE: [
        {types: ['string']},
        {types: ['primitiveObject', 'undefined']},
        {types: ['string', 'undefined']},
    ],
    REMOVE_FROM_CALL_CONFERENCE: [
        {types: ['string']},
        {types: ['string', 'undefined']},
    ],
    DESTROY_CALL_CONFERENCE: [{types: ['string', 'undefined']}],
    INVITE_TO_CHAT_CONFERENCE: [
        {types: ['string']},
        {types: ['string', 'undefined']},
    ],
    REMOVE_FROM_CHAT_CONFERENCE: [
        {types: ['string']},
        {types: ['string', 'undefined']},
    ],
    MERGE_ALL_CALLS_INTO_CONFERENCE: [{types: ['primitiveObject', 'undefined']}],
    GET_TEAMS: [],
    GET_TEAM_MEMBERS: [{types: ['string']}],
    GET_SERVICES_LIST: [],
    GET_SERVICE: [],
    SET_SERVICE: [{types: ['string', 'null']}],
    GET_DID_LIST: [],
    GET_DID: [],
    SET_DID: [{types: ['string', 'null']}],
    GET_DISPOSITIONS_LIST: [{types: ['dispositionTarget']}],
    SET_DISPOSITION: [
        {types: ['string']},
        {types: ['string', 'undefined']},
    ],
    ADD_NOTE: [
        {types: ['string']},
        {types: ['string', 'undefined']},
    ],
    UPDATE_NOTE: [
        {types: ['string']},
        {types: ['string', 'undefined']},
    ],
    REPLACE_NOTE: [
        {types: ['string']},
        {types: ['string', 'undefined']},
    ],
    SET_RESCHEDULE: [
        {types: ['rescheduleData']},
        {types: ['string', 'undefined']},
    ],
    GET_CONFIG: [],
    SET_VARIABLE: [
        {types: ['string']},
        {types: ['string']},
        {types: ['string', 'undefined']},
    ],
    GET_VARIABLES: [
        {types: ['arrayOfStrings']},
        {types: ['string', 'undefined']},
    ],
    ADD_INTERACTION_ASSOCIATED_OBJECT: [
        {types: ['interactionAssociatedObject']},
        {types: ['string', 'undefined']},
    ],
    SET_INTERACTION_ACTIVE_SCREEN: [
        {types: ['primitiveObject']},
        {types: ['string', 'undefined']},
    ],
    GET_PHONE_DEVICES_LIST: [],
    GET_PHONE_DEVICE: [],
    SET_PHONE_DEVICE: [{types: ['phoneDeviceData']}],
    SET_CALL_HOLD: [
        {types: ['boolean']},
        {types: ['string', 'undefined']},
    ],
    SET_CALL_RECORDING: [
        {types: ['boolean']},
        {types: ['string', 'undefined']},
    ],
    SET_CALL_MUTE: [
        {types: ['boolean']},
        {types: ['string', 'undefined']},
    ],
    SET_SCREEN_RECORDING_MUTE: [{types: ['boolean']}],
    GET_SCREEN_RECORDING_STATE: [],
    SET_WIDGET_MINIMIZED: [{types: ['boolean']}],
    SEND_CHAT_MESSAGE: [
        {types: ['string']},
        {types: ['string', 'undefined']},
    ],
    SUGGEST_CHAT_MESSAGE: [
        {types: ['string']},
        {types: ['boolean', 'undefined']},
        {types: ['string', 'undefined']},
    ],
    GET_AGENT_NOT_READY_REASONS: [],
    ACTIVATE_PAGE: [],
    GET_INTERACTIONS_STATE: [],
    SET_CALL_RECORDING_MUTE: [
        {types: ['boolean']},
        {types: ['string', 'undefined']},
    ],
    SET_DIAL_CANDIDATES: [{types: ['dialCandidates']}],
    GET_CHAT_TRANSCRIPT: [{types: ['string', 'undefined']}],
    GET_VOICE_TRANSCRIPT: [{types: ['string', 'undefined']}],
}

export const callbackResponseMessageTypeConstraints: Record<CallbackMessageWithResponse, Constraint[]> = {
    ON_SAVE_ACTIVITY_RECORD: [{types: ['activityHistoryInfo', 'undefined']}],
    ON_REQUEST_TRANSFER_DATA: [{types: ['primitiveObject', 'null']}],
    ON_SEARCH_KNOWLEDGE_BASE: [{types: ['externalKBSearchResults']}],
    ON_GET_KNOWLEDGE_BASE_ARTICLE: [{types: ['externalKBArticle', 'null']}],
    ON_GET_KNOWLEDGE_BASE_FOLDER: [{types: ['externalKBItems']}],
    ON_WEB_SCREEN_POP_CUSTOM: [{types: ['boolean']}],
    ON_VALIDATE_ASSOCIATED_RECORDS: [{types: ['recordsValidationResult']}],
    ON_REQUEST_RECORD_INFO: [{types: ['interactionAssociatedObject', 'null']}],
    ON_REQUEST_RECORD_ON_SCREEN: [{types: ['interactionAssociatedObject', 'null']}],
}
